module.exports = __webpack_public_path__ + "media/video.1cff4a02.mp4";